import { render, staticRenderFns } from "./Multiselect.vue?vue&type=template&id=21ea3391&scoped=true"
import script from "./Multiselect.vue?vue&type=script&lang=js"
export * from "./Multiselect.vue?vue&type=script&lang=js"
import style0 from "./Multiselect.vue?vue&type=style&index=0&id=21ea3391&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ea3391",
  null
  
)

export default component.exports